"use strict";

import jQuery from 'jquery';
import Flickity from 'flickity';
import jQueryBridget from 'jquery-bridget';
import lozad from 'lozad';

import '../grid/raster.dev.css';
import '../../node_modules/flickity/dist/flickity.css';
import '../sass/app.scss';

(function( $ ) {

	Flickity.setJQuery( $ );
	jQueryBridget( 'flickity', Flickity, $ );

	var didScroll,
		lastScrollTop = 0,
		delta = 5,
		navbarHeight;

	function calculateRealVH() {
		let vh = window.innerHeight * 0.01;
  		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}

	function get_last_segment(link) {
		var location = link.split('/');
		var last = location[location.length - 1];
		if(!last) {
			last = location[location.length - 2];
		}
		return last;
	}

	function get_first_segment(link) {
		var location = link.split('/');
		var first = location[0];
		if(!first) {
			first = location[1];
		}
		return first;
	}

	function updateSliderStatus(instance) {
		var i = instance.selectedIndex + 1;
	  	$('.slider-counter').text(i + '/' + instance.cells.length);
  	 	$('.l-dida').html($(instance.selectedElement).data('dida'));
	}

	function hasScrolled() {
	    var st = $('.grid-right').scrollTop();
	    if(Math.abs(lastScrollTop - st) <= delta) {
	        return;
	    }
	    if (st > lastScrollTop && st > navbarHeight){
	        // Scroll Down
	        $('.mobile-menu').removeClass('nav-down').addClass('nav-up');
	    } else {
	        // Scroll Up
	        $('.mobile-menu').removeClass('nav-up').addClass('nav-down');
	    }
	    lastScrollTop = st;
	}

	function closeLightbox() {
		$('.lightbox').hide();
		if($('.lightbox .carousel').data('flickity')) {
			$('.main-carousel').flickity('select', $('.lightbox .carousel').data('flickity').selectedIndex,false,true);
			$('.lightbox .carousel').flickity('destroy');
		}
		$('.lightbox .carousel').empty();
	}

	function toggleAccordionMenu(obj) {
		$(obj).next().toggle();
		$(obj).text($(obj).text() == '+' ? '-' : '+');
	}

	function toggleAccordion(obj) {
	    $('.toggle').each(function(index, elem) {
	    	$(elem).removeClass('active');
	    });
	    if ($(obj).next().hasClass('show')) {
	        $(obj).next().removeClass('show');
	        $(obj).next().hide();
	        $(obj).removeClass('active');
	    } else {
	        $(obj).parent().parent().find('li .inner').removeClass('show');
	        $(obj).parent().parent().find('li .inner').hide();
	        $(obj).next().toggleClass('show');
	        $(obj).next().toggle();
	        $(obj).addClass('active');
	    }
	}

	$(function() {

		const observer = lozad();
		observer.observe();
    
    	//menu hover
    	$(".grid-left nav a").on({
		    mouseenter: function () {
		        var img = $(this).data('img');
		        var parentId = $(this).closest('li[id]').attr('id');
				if(img) {
		        	$('.highlight-image div').css('background-image',img).show();
		        	if(parentId == 'menu-curators' || parentId == 'menu-coordinators' || parentId == 'menu-juries') {
		        		$('.highlight-image').addClass('person-highlight-image');
		        	}
		        	$('.grid-right, .instagram-box').hide();
		        	if( ! $('body').hasClass('page-template-home') ) {
		        		$('.btr').show();
		        	}
		        }
		    },
		    mouseleave: function () {
		    	$('.highlight-image').removeClass('person-highlight-image');
		        $('.highlight-image div').css('background-image','none').hide();
		    	$('.grid-right, .instagram-box').show();
		    	if( ! $('body').hasClass('page-template-home') ) {
		    		$('.btr').hide();
		    	}
		    }
		});

		$(".grid-left nav a").on('click', function() {
			if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')) {
				$('.highlight-image').removeClass('person-highlight-image');
				$('.highlight-image div').css('background-image','none').hide();
				$('.grid-right, .instagram-box').show();
				if( ! $('body').hasClass('page-template-home') ) {
					$('.btr').hide();
				}
		    }
		});

		//carousel
		if($('.main-carousel').length) {
			$('.main-carousel').flickity({
			  cellAlign: 'left',
			  contain: true,
			  prevNextButtons: false,
  			  pageDots: false,
  			  wrapAround: true,
  			  draggable: 'ontouchstart' in window,
  			  on: {
  			  	ready: function() {
  			  		setTimeout(function() {
  			  			var instance = $('.main-carousel').data('flickity');
  			  			updateSliderStatus(instance);
  			  		}, 10);
  			  	},
  			  	select: function() {
  			  		setTimeout(function() {
	  			  		var instance = $('.main-carousel').data('flickity');
	  			  		updateSliderStatus(instance);
	  			  	}, 10);
  			  	}
  			  }
			});
		}

		//accordion menu
		$('.menu-toggle').on('click', function() {
			toggleAccordionMenu($(this));
		});

		//click su ancore aggiusta scroll e apre eventuale accordion (solo se nella stessa pagina)
		$("a[href*=\\#]:not([href=\\#])").click(function() {
		    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')) {
		      var obj = $(this);
		      var target = this.hash;
		      if($(target).hasClass('toggle')) {
		      	toggleAccordion($(target));
		      }
		      target = target.replace('#','');
		      if (target.length) {
		      	setTimeout(function() {
		      		$('.grid-right').scrollTop(document.getElementById(target).offsetTop - 100);
		      	}, 10);
		      }
		    }
		});

		//scroll to hash
		if (location.hash) {
		    var target = location.hash;
		    if($(target).hasClass('toggle')) {
	      		toggleAccordion($(target));
			}
		    target = target.replace('#','');
		    var offset = document.getElementById(target).offsetTop - 100;
		    setTimeout(function() {
		    	$('.grid-right').scrollTop(offset);
		    }, 10);
		}

		//open menu accordion if in sub pages
		if (window.location.pathname != '/') {
			var menuObj = $('#menu-' + get_first_segment(window.location.pathname));
			if( ! $(menuObj).find('ul').is(':visible')) {
				toggleAccordionMenu($(menuObj).find('.menu-toggle'));
			}
		}

		$('.carousel-cell').on( 'click', function() {
			var count = 0;
			$('.lightbox').show();
			$(this).closest('.cells-container').find('.carousel-cell').each(function(index, elem) {
				var image = '<div class="carousel-cell" style="background-image:url(' + $(elem).attr('data-img') + ');" data-i="' + $(elem).attr('data-i') + '" data-dida="' + $(elem).attr('data-dida') + '"></div>';
				$('.lightbox .carousel').append(image);
				count++;
			});
			$('.lightbox .carousel').flickity({
			  cellAlign: 'left',
			  contain: true,
			  prevNextButtons: false,
  			  pageDots: false,
  			  wrapAround: true,
  			  draggable: 'ontouchstart' in window,
  			  on: {
  			  	ready: function() {
  			  		setTimeout(function() {
  			  			var instance = $('.lightbox .carousel').data('flickity');
  			  			updateSliderStatus(instance);
  			  		}, 10);
  			  	},
  			  	select: function() {
  			  		setTimeout(function() {
	  			  		var instance = $('.lightbox .carousel').data('flickity');
	  			  		updateSliderStatus(instance);
	  			  	}, 10);
  			  	}
  			  }
			});
			$('.lightbox .carousel').flickity('select', $(this).data('i'),false,true);
			if(count == 1) {
				$('.lightbox .lightbox-controls, .lightbox .previous--area, .lightbox .next--area').hide();
			}
			else {
				$('.lightbox .lightbox-controls, .lightbox .previous--area, .lightbox .next--area').show();
			}
		});

		// previous
		$('.button--previous, .previous--area').on( 'click', function() {
			var activeCarousel = $('.lightbox .carousel').data('flickity') ? $('.lightbox .carousel') : $('.main-carousel');
			$(activeCarousel).flickity('previous');
		});
		// next
		$('.button--next, .next--area').on( 'click', function() {
			var activeCarousel = $('.lightbox .carousel').data('flickity') ? $('.lightbox .carousel') : $('.main-carousel');
			$(activeCarousel).flickity('next');
		});

		$('.lightbox-close').on( 'click', function() {
			closeLightbox();
		});

		$(document).keyup(function(e) {
			if($('.lightbox').is(':visible')) {
				if (e.keyCode === 27) {
					closeLightbox();
				}
				else if (e.keyCode === 37) {
					$('.lightbox .carousel').flickity('previous');
				}
				else if (e.keyCode === 39) {
					$('.lightbox .carousel').flickity('next');
				}
			}
		});

		// mobile
		if ($(window).width() < 768) {

			$('.bigtypo.btl h1').each(function(index, elem){
				var newtypo = $(elem).text().replace(/(.{1})/g, "$1<br>");
		    	$(elem).html(newtypo.toUpperCase());
		    	$(elem).parent().css('height',$(elem).height());
				$('.btr').remove();
			});

			if($('.bigtypo.btl').length) {
				$('.grid-left, .grid-right').scroll(function() {
					requestAnimationFrame(() => {
						// calculate the percentage the user has scrolled down the page
					    var scrollPercent = $(this)[0].scrollTop / ($(this)[0].scrollHeight - $(this)[0].offsetHeight);
					    // get the height of the sticky element
					    var stickyHeight = $('.bigtypo.btl').height();
					    // calculate the margin top of the sticky element
					    var y = (($(window).height() - stickyHeight)) * scrollPercent;
					    // set margin top of sticky element
					    $('.bigtypo.btl').css('transform', 'translateY(' + y + 'px)');
					});
				});
			}

			//back to top
			$('.back-to-top').on('click',function(){
				if($('body').hasClass('page-template-home')) {
					$('.grid-left').scrollTop(0);
				}
				else {
					$('.grid-right').scrollTop(0);
				}
			});

			// Hide Header on scroll down
			navbarHeight = $('.mobile-menu').outerHeight();
			$('.grid-right').scroll(function(){
			    didScroll = true;
			});
			setInterval(function() {
			    if (didScroll) {
			        hasScrolled();
			        didScroll = false;
			    }
			}, 10);

		}

		calculateRealVH();

	});

	window.addEventListener('resize', () => {
		calculateRealVH();
	});

})(jQuery);